// Phase 6 — Track C T-C2 + Track F T-F2. SPA entry point.
//
// Mounts the React tree onto #root. Providers owns the QueryClient,
// ThemeProvider, BrowserRouter, AuthProvider, root ErrorBoundary, and
// Toaster; AppRoutes owns the route table.
//
// Track F T-F2: production-only service worker registration after
// `window.load`. Dev mode skips registration to avoid HMR conflicts.

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from './app/providers.js';
import { AppRoutes } from './app/router.js';
import './styles/globals.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootEl).render(
  <React.StrictMode>
    <Providers>
      <AppRoutes />
    </Providers>
  </React.StrictMode>,
);

// Service worker registration — production-only.
//
// `import.meta.env.PROD` is statically replaced by Vite at build time, so
// in `vite dev` the entire branch is dead code (no SW registration, no
// HMR conflict). On a production build, registration runs after
// `window.load` to avoid competing with first paint, and registration
// failures are logged to the console only — never to a remote endpoint
// (blueprint §20.3).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .catch((err: unknown) => {
        // eslint-disable-next-line no-console
        console.warn('[sw] registration failed', err);
      });
  });
}
